"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var OrderServiceContext_1 = require("../OrderServiceContext");
var FormSubmitView = function (props) {
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    var _b = (0, OrderServiceContext_1.useOrderServiceContext)(), isConditionAccept = _b.isConditionAccept, payment = _b.payment, orderService = _b.orderService, currency = _b.currency;
    return (react_1.default.createElement(react_2.Fragment, null,
        react_1.default.createElement("button", { disabled: (isConditionAccept && !props.onClick && (payment !== undefined)) ? false : true, type: "submit" },
            react_1.default.createElement("b", null, t("service.view.order.submit")))));
};
exports.default = FormSubmitView;
